export const acceptedCountryCodes = ["+1", "+61", "+44", "+43", "+41", "+49"];

// hiding +353 (Ireland) for now
